import { JSX } from "react";


export default function NoDataFound(): JSX.Element {
  return (
    <p className="m-0 alert alert-warning p-2 text-center" style={{minWidth:300}}>No Data Available</p>
  );
};
